import { normalizeMultilingualValue } from "@/utils/multilingual";

const RELATION_FIELDS = [
  "softwares",
  "publications",
  "projects",
  "authors",
  "internal_holders",
  "exploitation_organizations",
  "holder_organizations"
];

export function createDefaultIndustrialProperty() {
  return {
    id: null,
    slug: "",
    title: "",
    description: normalizeMultilingualValue(""),
    property_type: "patent",
    application_number: "",
    application_date: "",
    usc_percentage: 100,
    parent_patent_title: "",
    publication_number: "",
    publication_date: "",
    grant_date: "",
    country_code: "",
    patent_code: "",
    patent_url: "",
    patent_status: "pending",
    softwares: [],
    publications: [],
    projects: [],
    authors: [],
    internal_holders: [],
    external_holders: [""],
    exploitation_organizations: [],
    holder_organizations: []
  };
}

function relationIds(items) {
  if (!Array.isArray(items)) return [];
  return Array.from(new Set(items.map(item => {
    if (item && typeof item === "object") {
      return item.id !== undefined && item.id !== null ? item.id : item.value;
    }
    return item;
  }).filter(value => value !== undefined && value !== null && value !== "")));
}

export function normalizeIndustrialProperty(payload = {}) {
  const normalized = {
    ...createDefaultIndustrialProperty(),
    ...payload,
    description: normalizeMultilingualValue(payload.description || ""),
    application_date: payload.application_date || "",
    publication_date: payload.publication_date || "",
    grant_date: payload.grant_date || "",
    external_holders: Array.isArray(payload.external_holders) && payload.external_holders.length
      ? payload.external_holders
      : [""]
  };
  RELATION_FIELDS.forEach(field => {
    normalized[field] = relationIds(payload[field]);
  });
  return normalized;
}

export function serializeIndustrialProperty(property) {
  const payload = {
    title: property.title || "",
    description: normalizeMultilingualValue(property.description),
    property_type: property.property_type || "patent",
    application_number: property.application_number || "",
    application_date: property.application_date || null,
    usc_percentage: Number(property.usc_percentage),
    parent_patent_title: property.property_type === "patent" ? property.parent_patent_title || "" : "",
    publication_number: property.property_type === "patent" ? property.publication_number || "" : "",
    publication_date: property.property_type === "patent" ? property.publication_date || null : null,
    grant_date: property.property_type !== "software_registration" ? property.grant_date || null : null,
    country_code: property.property_type === "patent" ? property.country_code || "" : "",
    patent_code: property.property_type === "patent" ? property.patent_code || "" : "",
    patent_url: property.property_type === "patent" ? property.patent_url || "" : "",
    patent_status: property.patent_status || "pending",
    external_holders: (property.external_holders || []).filter(value => value && value.trim())
  };
  RELATION_FIELDS.forEach(field => {
    payload[field] = relationIds(property[field]);
  });
  return payload;
}
